import React from "react";

import { Box, Divider } from "@mui/material";

// --------------------------------------------------------------------------------------------------
export default function FractionFormula({
  supText,
  subText,
  textAfter = <span style={{ whiteSpace: "nowrap" }}>&times; 100%</span>,
}) {
  return (
    <Box display={"flex"} justifyContent={"center"} alignItems={"center"} gap={1}>
      <Box display={"flex"} flexDirection={"column"}>
        <span>{supText}</span>
        <Divider />
        <span>{subText}</span>
      </Box>
      {textAfter}
    </Box>
  );
}
